document.addEventListener("DOMContentLoaded", function () {

  // Quantity input typing
  document.querySelectorAll(".cart-qty-input").forEach(input => {
    input.addEventListener("change", function () {
      let line = this.dataset.line;
      updateLine(line, this.value);
    });
  });


  // PLUS BUTTON
  document.querySelectorAll(".js-qty__adjust--plus").forEach(btn => {
    btn.addEventListener("click", function () {

      let input = this.closest(".js-qty").querySelector(".cart-qty-input");
      let qty = parseInt(input.value) + 1;

      input.value = qty;
      updateLine(input.dataset.line, qty);

    });
  });


  // MINUS BUTTON
  document.querySelectorAll(".js-qty__adjust--minus").forEach(btn => {
    btn.addEventListener("click", function () {

      let input = this.closest(".js-qty").querySelector(".cart-qty-input");
      let qty = Math.max(0, parseInt(input.value) - 1);

      input.value = qty;
      updateLine(input.dataset.line, qty);

    });
  });


  // REMOVE BUTTON
  document.querySelectorAll(".cart-remove").forEach(btn => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      updateLine(this.dataset.line, 0);
    });
  });

});



function updateLine(line, qty) {

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      line: line,
      quantity: qty
    })
  })
  .then(res => res.json())
  .then(cart => refreshCart(cart));

}



function refreshCart(cart) {

  // Update subtotal
  document.querySelectorAll(".cart-subtotal, .cart__subtotal .money").forEach(el=>{
    el.innerHTML = Shopify.formatMoney(cart.total_price);
  });

  // Update each product row
  cart.items.forEach((item, index) => {

    let line = index + 1;

    // Update quantity input
    let input = document.querySelector(`.cart-qty-input[data-line="${line}"]`);
    if(input) input.value = item.quantity;

    // Update line price
    let price = document.querySelector(`[data-line-price="${line}"]`);
    if(price) price.innerHTML = Shopify.formatMoney(item.final_line_price);

  });

}